import FormularioPago from '@components/usuario/RenovacionLicencia/FormularioPago';
import React, { useEffect, useState } from 'react'

const RenovacionLicenciaSuscripcion = () => {
 const [showLoader, setShowLoader] = useState(true);
 
    const [showCheckout, setShowCheckout] = useState(true);
    
    useEffect(() => {
        setTimeout(() => {
            setShowLoader(false);
        }, 1800);
    }, []);
 
    return (
        <>
            <FormularioPago />
        </>
    );
}

export default RenovacionLicenciaSuscripcion